<template>
    <div>
        <v-text-field dense outlined @focus="colorPickerDialog = true" @input="EmitColor" @change="EmitColor" :label="label" v-model="color">
            <template v-slot:append>
              <span :style="'background-color:'+color+';'"  class="color-picker-preview"></span>
            </template>
          </v-text-field>
          <template>
            <v-dialog v-model="colorPickerDialog" max-width="300" persistent>
                <v-card>
                  <v-card-title>
                    انتخاب رنگ
                  </v-card-title>
                  <v-card-text>
                    <v-color-picker v-model="color"></v-color-picker>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn small color="blue accent-2" @click="Close()" outlined>بستن</v-btn>
                  </v-card-actions>
                </v-card>
            </v-dialog>
          </template>
    </div>
</template>
<style scoped>
    .color-picker-preview
    {
      width: 1.1rem;
      height: 1.1rem;
      display: block;
      margin-top: 0.1rem;
      box-sizing: border-box;
      border: .01rem solid;
  
    }
</style>
<script>
export default{
 name:"CustomColorPicker",
 props:["color","label"],
 data:()=>({
    colorPickerDialog:false,
    Color:""
 }),
 created(){
    this.Color = this.color;
 },
 methods:{
  Close()
    {
        var vm = this;
        vm.colorPickerDialog = false;
        vm.$emit('Selected',vm.Color)
    },
    EmitColor()
    {
        var vm = this;
        vm.$emit('Selected',vm.Color)
    }
 },
 mounted:{
  ListenToColor()
  {
    this.color = this.Color;
  }
 },
 watch:{
    color:function(v,ov){
        var vm = this;
        if(ov == null || ov == "")
        {
          ov = "#ffffff";
        }
        vm.Color = ov;
    }
 }
}
</script>
